// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"Subtitle_subtitle__KBlmD","actions":"Subtitle_actions__qyUNR","doneButton":"Subtitle_doneButton__3b-DO"};